import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import userSlice from "./slices/userSlice";
import sportsSlice from "./slices/sportsSlice";
import myBookingSlice from "./slices/myBookingSlice";
import eventsSlice from "../containers/events-category/slice";
import salonSlice from "../containers/salon/slice";
import carWashSlice from "./slices/carWashSlice";
import fitnessSlice from "../containers/fitness/slice";
import foodSlice from "../containers/food-category/slice";
import laundrySlice from "../containers/laundry/slice";
import homeServicesReducer from "../containers/home-services/slice";

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  myBooking: myBookingSlice,
  sports: sportsSlice,
  events: eventsSlice,
  salon: salonSlice,
  fitness: fitnessSlice,
  carWash: carWashSlice,
  food: foodSlice,
  laundry: laundrySlice,
  homeServices: homeServicesReducer,
});

export default rootReducer;
